(() => {
  'use strict';

  const REVIEWS_PER_PAGE = 6;
  const REVIEWS_ENDPOINT = '/reviews/reviews_for_widget';

  const installFetchOverride = () => {
    if (!window.fetch || window.fetch.__spartanJudgeMeCompact) return;

    const originalFetch = window.fetch;

    const compactFetch = function (input, init) {
      const requestUrl =
        input instanceof Request
          ? input.url
          : input instanceof URL
            ? input.toString()
            : String(input);

      if (!requestUrl.includes(REVIEWS_ENDPOINT)) {
        return originalFetch.call(this, input, init);
      }

      const url = new URL(requestUrl, window.location.origin);
      url.searchParams.set('per_page', String(REVIEWS_PER_PAGE));

      const compactInput =
        input instanceof Request
          ? new Request(url.toString(), input)
          : url.toString();

      return originalFetch.call(this, compactInput, init);
    };

    compactFetch.__spartanJudgeMeCompact = true;
    window.fetch = compactFetch;
  };

  const patchWidgetData = (data) => {
    if (!data || typeof data !== 'object') return data;

    const totalReviews = Number(data.number_of_reviews) || 0;

    if (Array.isArray(data.reviews)) {
      data.reviews = data.reviews.slice(0, REVIEWS_PER_PAGE);
    }

    if (data.pagination && typeof data.pagination === 'object') {
      data.pagination.per_page = REVIEWS_PER_PAGE;
      data.pagination.total_pages = Math.max(
        1,
        Math.ceil(totalReviews / REVIEWS_PER_PAGE)
      );
    }

    return data;
  };

  window.jdgm = window.jdgm || {};
  window.jdgm.data = window.jdgm.data || {};
  installFetchOverride();

  const reviewWidgetData = window.jdgm.data.reviewWidget || {};

  Object.keys(reviewWidgetData).forEach((productId) => {
    reviewWidgetData[productId] = patchWidgetData(reviewWidgetData[productId]);
  });

  window.jdgm.data.reviewWidget = new Proxy(reviewWidgetData, {
    set(target, productId, value) {
      target[productId] = patchWidgetData(value);
      return true;
    },
  });

  if (window.jdgmSettings && typeof window.jdgmSettings === 'object') {
    window.jdgmSettings.pagination = REVIEWS_PER_PAGE;
  }

  document.documentElement.classList.add('spartan-judgeme-compact');
})();
